<template>
  <a-form
    class="simiot-nested-search-form diagnose-search-form"
    :form="form"
    @submit="handleSearch"
  >
    <a-row :gutter="24">
      <a-col :span="6">
        <a-form-item>
          <a-space>
            <a-button type="primary" html-type="submit">
              开始诊断
            </a-button>
            <a-button
              type="primary"
              v-if="isChinaMobileV5"
              :loading="resetLoading"
              @click="handleNetReset"
            >
              重置通信
            </a-button>
          </a-space>
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { findSimCardIsChinaMobileV5, netResetSimCard } from '@/api/sim_card'

export default {
  name: 'SearchSimCardDiagnose',
  props: {
    simCardId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'sim_card_diagnose_search' }),
      isChinaMobileV5: false,
      resetLoading: false
    }
  },
  watch: {
    simCardId: {
      immediate: true,
      handler() {
        this.fetchIsChinaMobileV5()
      }
    }
  },
  methods: {
    fetchIsChinaMobileV5() {
      findSimCardIsChinaMobileV5(this.simCardId).then((res) => {
        if (res.code === 0) {
          this.isChinaMobileV5 = !!res.data.is_china_mobile_v5
        } else {
          this.isChinaMobileV5 = false
        }
      }).catch(() => {
        this.isChinaMobileV5 = false
      })
    },

    handleNetReset() {
      this.resetLoading = true
      netResetSimCard(this.simCardId).then((res) => {
        if (res.code === 0) {
          this.$message.success('重置通信成功')
        } else {
          this.$message.error(res.message || '重置通信失败')
        }
      }).finally(() => {
        this.resetLoading = false
      })
    },

    handleReset() {
      this.form.resetFields()
      this.$emit('submit', {})
    },

    handleSearch(e) {
      e.preventDefault()
      this.$emit('submit', this.form.getFieldsValue())
    }
  }
}
</script>

<style lang="less" scoped>
.diagnose-search-form {
  margin-bottom: 10px;
}
</style>
